<ng-container *ngIf="hotel">
    <app-tabs 
        [setActiveTabIndexAs]="activeHotelTabIndex"
        [setActiveTabContentOverrideIndexAs]=2
        [buttonsData]="hotelSuitesTabs"
        tabsClassname="_tabs-x _tabs-styled-primary _mb-5 _mt-4"
        buttonClassname="_h-12"
        buttonActiveClassname="_bg-primary-1 _text-grayscale-white"
        (tabSwitched)="setActiveSuite($event)">

        <ng-container slot="tab-content">
            <div data-tab-content-index="1">
                <app-feature-image [images]="listing.summary.photos" (imageClickEvent)="viewPhotos(listing.summary.photos)" class="_cursor-pointer">
                          
                    <div slot="modal-trigger" class="_mask">
                        <div class="_flex _justify-center _items-center _w-full _h-full _cursor-pointer"
                            (click)="viewPhotos(this.listing.summary.photos)">
                                {{ listing.summary.photos.length }} photos
                        </div>
                    </div>
                </app-feature-image>

                <div class="_mt-8">
                    <div class="_flex _flex-col xs:_flex-row _w-full md:_min-h-22">
                        <div class="_flex _items-center _justify-center xs-max:_mb-2">
                            <app-listing-host [listingId]="listing.listingId"></app-listing-host>
                        </div>

                        <span class="_flex _items-center xs:_ml-4 _justify-center xs:_justify-start">
                            <app-listing-heading [listing]="listing"></app-listing-heading>
                        </span>
                    </div>

                    <div class="_flex">
                        <div class="_flex _flex-col sm:_flex-row _flex-nowrap _mt-4">
                            <div class="_py-2">
                                <div class="_pb-8 _border-b _border-primary-1-tint-10">
                                    <div class="_flex _flex-row _flex-wrap _items-center _justify-between _border-t _border-b _border-primary-1-tint-10 _py-2 _px-4">

                                        <div class="_flex _justify-center _w-1/2 xs:_w-auto _py-2">
                                            <span class="_pill">{hotel.suites.length, plural, =1 {1 Private suite} other {{{hotel.suites.length}} Private suites}}</span>
                                        </div>

                                        <div class="_flex _justify-center _w-1/2 xs:_w-auto _py-2">
                                            <img class="_h-4 _w-4 _mr-2" src="/assets/icon/guests.svg" alt="guest icon">
                                            <span class="_text-md-m md:_text-lg">
                                                {occupancyRange, plural, =1 {1 guest} other {{{occupancyRange}} guests}}
                                            </span>
                                        </div>

                                        <div class="_flex _justify-center _w-1/2 xs:_w-auto _py-2">
                                            <img class="_h-4 _w-4 _mr-2" src="/assets/icon/bedrooms.svg" alt="bedrooms icon">
                                            <span class="_text-md-m md:_text-lg">
                                                {bedroomsRange, plural, =1 {1 bedroom} other {{{bedroomsRange}} bedrooms}}
                                            </span>
                                        </div>

                                        <!-- TODO ONCE HAVE BATHROOM DATA
                                        <div class="_flex _justify-center _w-1/2 xs:_w-auto _py-2">
                                            <img class="_h-4 _w-4 _mr-2" src="/assets/icon/bathrooms.svg" alt="bathroom icon">
                                            <span class="_text-md-m md:_text-lg">
                                                {property.general.bathrooms, plural, =1 {1 bathroom} other {{{property.general.bathrooms}} bathrooms}}
                                            </span>
                                        </div> -->
                                    </div>

                                    <ng-container *ngIf="hotel.general.description">
                                        <div class="_p-4">
                                            <app-expandable-content-container
                                                previewSize="200px"
                                                buttonBottomOffset="-20px">
                                                <app-markdown-renderer [text]="hotel.general.description"></app-markdown-renderer>
                                            </app-expandable-content-container>
                                        </div>
                                    </ng-container>

                                    <div class="_pb-8 _border-b _border-primary-1-tint-10" hidden="hidden">
                                        <div class="_flex _gap-4 _justify-end">
                                            <span class="_link"><i class="fa-light fa-share-nodes"></i> <span>Share link</span></span>
                                            <span class="_link"><i class="fa-light fa-arrow-down-to-line"></i> <span>Download</span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div data-tab-content-index="2">
                <div class="_relative">
                    <app-feature-image [images]="selectedHotelSuite.imagery.photos" (imageClickEvent)="viewPhotos(selectedHotelSuite.imagery.photos)" class="_cursor-pointer">
                        <div slot="modal-trigger" class="_mask">
                            <div class="_flex _justify-center _items-center _w-full _h-full _cursor-pointer"
                                (click)="viewPhotos(selectedHotelSuite.imagery.photos)">
                                    {{ selectedHotelSuite.imagery.photos.length }} photos
                            </div>
                        </div>
                    </app-feature-image>

                    <ng-content select="[slot=add-to-wishlist-favorites]"></ng-content>
                </div>
                <div class="_mt-8">
                    <div class="_flex _flex-col xs:_flex-row _w-full md:_min-h-22">
                        <div class="_flex _items-center _justify-center xs-max:_mb-2">
                            <app-listing-host [listingId]="listing.listingId"></app-listing-host>
                        </div>

                        <span *ngIf="listing" class="_col-span-8 xs:_col-span-7 _flex _items-center xs:_ml-4 _justify-center xs:_justify-start">
                            <h1 class="_text-h4-m md:_text-h2 _text-center sm:_text-left">
                                {{selectedHotelSuiteName}}
                            </h1>
                        </span>
                    </div>

                    <div class="_flex _col-span-8">

                        <div class="_flex">
                            <div class="_flex _flex-col sm:_flex-row _flex-nowrap _mt-4">
                                <div>
                                    <div class="_pb-8 _border-b _border-primary-1-tint-10">
                                        <div class="_flex _flex-row _flex-wrap _items-center _justify-between _border-t _border-b _border-primary-1-tint-10 _py-2 _px-4">
                                            
                                            <div class="_flex _justify-center _w-1/2 xs:_w-auto _py-2">
                                                <span class="_pill">Private suite</span>
                                            </div>
            
                                            <div class="_flex _justify-center _w-1/2 xs:_w-auto _py-2">
                                                <img class="_h-4 _w-4 _mr-2" src="/assets/icon/guests.svg" alt="guest icon">
                                                <span class="_text-md-m md:_text-lg">
                                                    {selectedHotelSuite.guestRestrictions.maxOccupancy, plural, =1 {1 guest} other {{{selectedHotelSuite.guestRestrictions.maxOccupancy}} guests}}
                                                </span>
                                            </div>
            
                                            <div class="_flex _justify-center _w-1/2 xs:_w-auto _py-2">
                                                <img class="_h-4 _w-4 _mr-2" src="/assets/icon/bedrooms.svg" alt="bedrooms icon">
                                                <span class="_text-md-m md:_text-lg">
                                                    {selectedHotelSuite.rooms.bedrooms.length, plural, =1 {1 bedroom} other {{{selectedHotelSuite.rooms.bedrooms.length}} bedrooms}}
                                                </span>
                                            </div>
            
                                            <!-- TODO ONCE HAVE BATHROOM DATA
                                            <div class="_flex _justify-center _w-1/2 xs:_w-auto _py-2">
                                                <img class="_h-4 _w-4 _mr-2" src="/assets/icon/bathrooms.svg" alt="bathroom icon">
                                                <span class="_text-md-m md:_text-lg">
                                                    {property.general.bathrooms, plural, =1 {1 bathroom} other {{{property.general.bathrooms}} bathrooms}}
                                                </span>
                                            </div> -->
                                        </div>
            
                                        <ng-container *ngIf="selectedHotelSuite.description && showSuiteDescription">
                                            <div class="_p-4">
                                                <app-expandable-content-container
                                                    previewSize="200px"
                                                    buttonBottomOffset="-20px">
                                                    <app-markdown-renderer [text]="selectedHotelSuite.description"></app-markdown-renderer>
                                                </app-expandable-content-container>
                                            </div>
                                        </ng-container>
            
                                        <div class="_pb-8 _border-b _border-primary-1-tint-10" hidden="hidden">
                                            <div class="_flex _gap-4 _justify-end">
                                                <span class="_link"><i class="fa-light fa-share-nodes"></i> <span>Share link</span></span>
                                                <span class="_link"><i class="fa-light fa-arrow-down-to-line"></i> <span>Download</span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </app-tabs>

    <div *ngIf="hasDocuments" class="_py-6 _px-4 _border-b _border-primary-1-tint-10">
        <h4 class="_text-h4-m md:_text-h3">More resources</h4>
        <button class="_button-primary _mt-4" (click)="viewDocuments()">
            <i class="fa-sharp fa-light fa-eye _mr-1"></i>
            View more resources
        </button>
        <p class="_mt-5">We have gathered more resources about the accommodation and surrounding area (policies, brochures, videos, etc).</p>
    </div>

    <!-- TODO -->
    <!-- OLD STYLED COMPONENTS BELOW -->
    <div class="_py-6 _px-4" *ngIf="showFeatures">
        <h4 class="_h2">What we love</h4>

        <div class="size-2"></div>

        <app-listing-highlighted-feature
                [highlightedFeatures]="listing.summary.highlightedFeatures.features">
        </app-listing-highlighted-feature>
    </div>

    <div class="_py-6 _px-4">
        <div class="_flex _flex-col md:_flex-row _gap-4">
            <!-- Key Details Panel -->
            <div class="_w-full md:_w-1/2">
                <h4 class="_h2">Key details</h4>
                <div class="size-2"></div>
                <app-listing-house-rules [houseRules]="listing.summary.houseRules"></app-listing-house-rules>
            </div>

            <!-- Transport Panel -->
            <div class="_w-full md:_w-1/2">
                <h4 class="_h2">Transport</h4>
                <div class="size-2"></div>
                <app-listing-transport [lat]="hotel.location.geoLocation.lat"
                                       [lng]="hotel.location.geoLocation.lng"></app-listing-transport>
            </div>
        </div>
    </div>

    <div class="_py-6 _px-4">
        <app-listing-map [listing]="listing"></app-listing-map>
    </div>

    <div class="_py-6 _px-4">
        <app-listing-amenities [assetId]="listing.asset.assetId"
                            [amenities]="hotel.amenities"></app-listing-amenities>
    </div>

    <div class="_py-6 _px-4" *ngIf="hotel.goodToKnow?.description">
        <app-listing-good-to-know [goodToKnow]="hotel.goodToKnow?.description"
                                *ngIf="hotel.goodToKnow?.description"></app-listing-good-to-know>
    </div>

</ng-container>
